import { render } from "./PuzzlesHome.vue?vue&type=template&id=5848f301&scoped=true"
import script from "./PuzzlesHome.vue?vue&type=script&lang=js"
export * from "./PuzzlesHome.vue?vue&type=script&lang=js"

import "./PuzzlesHome.vue?vue&type=style&index=0&id=5848f301&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5848f301"]])

export default __exports__